import { MentionEntityKind, MentionPartyRole, MentionRole } from '@common/interfaces/mention'
import { MentionPurpose } from '@common/interfaces/mentions'
import Base from './base'

export default class Mentions extends Base {
  listSuggestions(params: { name?: string; purpose?: MentionPurpose } = {}) {
    return this.apiClient.get('mentions/suggestions', params)
  }

  list(data: object = {}) {
    return this.apiClient.get('mentions', data)
  }

  resolveRole(id: string, data: { role: MentionRole; kind: MentionEntityKind; entityId: string }) {
    return this.apiClient.put(`mentions/${id}/role`, data)
  }

  updateStatus(id: string, data: { status: string }) {
    return this.apiClient.put(`mentions/${id}/status`, data)
  }

  createLead(id: string, data: { role: MentionPartyRole; kind: MentionEntityKind; name?: string }) {
    return this.apiClient.post(`mentions/${id}/lead`, data)
  }
}
